import React from 'react'
import styled from 'styled-components'
import Modal from 'live/components/ui/Modal'
import '../../main/options/modalFull.scss'

interface Props {
    handleDelete: (event: React.MouseEvent) => void
    handleCancel: () => void
    show: boolean
}

export default function deleteConfirmationModal ({handleDelete, handleCancel, show}:Props) {
    return (
        <Modal show={show}  keyboard={false} className="deleteConfirmationModal" >
            <Modal.Header>
                <Modal.Title>
                    <TitleContainer>
                        <i class="fas fa-exclamation-circle"/> Attention!
                    </TitleContainer>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BodyContainer>
                    <div className="question">
                        Are you sure you want to delete this group model?
                    </div>
                    <div className="focus">
                        This action cannot be undone.
                    </div>
                </BodyContainer>
            </Modal.Body>
            <Modal.Footer>
                <FooterContainer>
                    <button className="delete" onClick={event => handleDelete(event)}>
                            Delete
                    </button>
                    or 
                    <button className="cancel" onClick={handleCancel}>
                            <u>cancel</u>
                    </button>
                </FooterContainer>
            </Modal.Footer>
        </Modal>
    )
}

const TitleContainer = styled.div`
    color: var(--red-700);
    font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
    font-size: 18px;
    i{
        font-size: 18px;
    }
`

const BodyContainer = styled.div`
    .question{
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        color: var(--gray-800);
        font-size: 14px;
        margin-bottom: 8px;
    }
    
    .focus{
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        color: var(--red-700);
        font-size: 14px;
    }
`

const FooterContainer = styled.div`
    font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
    .delete{
        background: var(--red-700);
        border-radius: 3px;
        margin-right: 4px;
        border: none;
        color: white;
        width: 79px;
        height: 32px;
    }
    .cancel{
        border: none;
        color: var(--blue-500);
        background: none;
        padding:0px;
        margin-left:4px;
    }

`